import { motion } from 'framer-motion';

const SpPageTransition = ({ children, style, className }) => (
  <motion.div className={className} style={style} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
    {children}
  </motion.div>
);

export default SpPageTransition;
